import moment from 'moment';

export function dateSort(a, b, order) {
	// order is desc or asc
	const dataA = Date.parse(a.data_pagamento);
	const dataB = Date.parse(b.data_pagamento);
	if (order === 'desc') {
		return dataA - dataB;
	}
	return dataB - dataA;
}

export function last7Day() {
	// const result = [];
	// for (let i = 0; i < 7; i += 1) {
	// 	const date = new Date();
	// 	date.setDate(date.getDate() - i);
	// 	result.push(date);
	// }

	return moment().subtract(7, 'days');
}

export function last30Days() {
	// const result = [];
	// for (let i = 0; i < 7; i += 1) {
	// 	const date = new Date();
	// 	date.setDate(date.getDate() - i);
	// 	result.push(date);
	// }

	return moment().subtract(30, 'days');
}

export function dataFinalAnteriorInicial(dataInicial, dataFinal) {
	const dataInit = new Date(dataInicial);
	const dataEnd = new Date(dataFinal);
	if (dataInit > dataEnd) {
		return true;
	}
	return false;
}
